export default __webpack_public_path__ + "media/images/prevu-0dca31464e853737f26554df521c1a86.png";